import React, { Component } from 'react'

export default class CheckBox extends Component {
  render(){

    const { classes, checked, onChange, label, name } = this.props;
    
    return(

      <div className={"checkbox " + classes} >
        <input 
          className="styled"
          type="checkbox"
          name={name}
          id={"id-" + name}
          checked={checked}
          onChange={onChange} />
        <label>
          {label}
        </label>
      </div>
      
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js